// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface SupportMedicalClaim
 */
export interface SupportMedicalClaim {
    /**
     * The chargemaster id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportMedicalClaim
     */
    chargemasterId?: string;
    /**
     * The guarantor id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportMedicalClaim
     */
    guarantorId?: string;
    /**
     * The primary TPA payer id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportMedicalClaim
     */
    primaryThirdPartyAdministratorPayerId?: string;
    /**
     * The secondary TPA payer id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportMedicalClaim
     */
    secondaryThirdPartyAdministratorPayerId?: string;
    /**
     * The tertiary TPA payer id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportMedicalClaim
     */
    tertiaryThirdPartyAdministratorPayerId?: string;
    /**
     * The subscriber and the relationship to the payer
     * OpenAPI data type: {array}
     * @type {Array<string>}
     * @memberof SupportMedicalClaim
     */
    payerSubscriberIds: Array<string>;
    /**
     * The patient and the relationship to the subscriber
     * OpenAPI data type: {array}
     * @type {Array<string>}
     * @memberof SupportMedicalClaim
     */
    subscriberPatientIds: Array<string>;
    /**
     * The various types of providers.
     * OpenAPI data type: {array}
     * @type {Array<string>}
     * @memberof SupportMedicalClaim
     */
    providerIds: Array<string>;
    /**
     * The seller id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportMedicalClaim
     */
    sellerId?: string;
    /**
     * The facility id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportMedicalClaim
     */
    facilityId?: string;
    /**
     * The claim id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportMedicalClaim
     */
    claimId: string;
}

export function SupportMedicalClaimFromJSON(json: any): SupportMedicalClaim {
    return {
            'chargemasterId': !exists(json, 'chargemasterId') ? undefined : json['chargemasterId'],
            'guarantorId': !exists(json, 'guarantorId') ? undefined : json['guarantorId'],
            'primaryThirdPartyAdministratorPayerId': !exists(json, 'primaryThirdPartyAdministratorPayerId') ? undefined : json['primaryThirdPartyAdministratorPayerId'],
            'secondaryThirdPartyAdministratorPayerId': !exists(json, 'secondaryThirdPartyAdministratorPayerId') ? undefined : json['secondaryThirdPartyAdministratorPayerId'],
            'tertiaryThirdPartyAdministratorPayerId': !exists(json, 'tertiaryThirdPartyAdministratorPayerId') ? undefined : json['tertiaryThirdPartyAdministratorPayerId'],
            'payerSubscriberIds': json['payerSubscriberIds'],
            'subscriberPatientIds': json['subscriberPatientIds'],
            'providerIds': json['providerIds'],
            'sellerId': !exists(json, 'sellerId') ? undefined : json['sellerId'],
            'facilityId': !exists(json, 'facilityId') ? undefined : json['facilityId'],
            'claimId': json['claimId'],
    };

}

export function SupportMedicalClaimToForm(value?: SupportMedicalClaim): any {
    let jsonVal = SupportMedicalClaimToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function SupportMedicalClaimToJSON(value?: SupportMedicalClaim): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'chargemasterId': cleanupBlankValuesForBackend(value.chargemasterId),
            'guarantorId': cleanupBlankValuesForBackend(value.guarantorId),
            'primaryThirdPartyAdministratorPayerId': cleanupBlankValuesForBackend(value.primaryThirdPartyAdministratorPayerId),
            'secondaryThirdPartyAdministratorPayerId': cleanupBlankValuesForBackend(value.secondaryThirdPartyAdministratorPayerId),
            'tertiaryThirdPartyAdministratorPayerId': cleanupBlankValuesForBackend(value.tertiaryThirdPartyAdministratorPayerId),
            'payerSubscriberIds': cleanupBlankValuesForBackend(value.payerSubscriberIds),
            'subscriberPatientIds': cleanupBlankValuesForBackend(value.subscriberPatientIds),
            'providerIds': cleanupBlankValuesForBackend(value.providerIds),
            'sellerId': cleanupBlankValuesForBackend(value.sellerId),
            'facilityId': cleanupBlankValuesForBackend(value.facilityId),
            'claimId': cleanupBlankValuesForBackend(value.claimId),
    };
}


